import { createFileRoute } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { keycloakQueries } from '@/http/api/keycloak'
import { Password } from '@/user/components/Settings/Password'
import { TwoFactorAuthentication } from '@/user/components/Settings/TwoFactorAuthentication'

export const Route = createFileRoute('/user/settings/security')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-security',
        }),
      },
    ],
  }),
  pendingComponent: () => <LoadingIndicator />,
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(keycloakQueries.credentials())
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Password />
      <TwoFactorAuthentication />
    </>
  )
}
